import instance from '../axios/axios';

/**
 * Add a report to user's favorites
 * @param {string|number} reportId - The ID of the report to favorite
 * @returns {Promise} - API response
 */
export const favoriteReport = async (reportId) => {
    try {
        const response = await instance.post(`/users/favorite/${reportId}`, {}, { 
            withCredentials: true 
        });
        return response;
    } catch (error) {
        console.error('Error favoriting report:', error);
        throw error;
    }
};

/**
 * Remove a report from user's favorites
 * @param {string|number} reportId - The ID of the report to unfavorite
 * @returns {Promise} - API response
 */
export const unfavoriteReport = async (reportId) => {
    try {
        const response = await instance.post(`/users/unfavorite/${reportId}`, {}, { 
            withCredentials: true 
        });
        return response;
    } catch (error) {
        console.error('Error unfavoriting report:', error);
        throw error;
    }
};

/**
 * Get user's favorite reports
 * @returns {Promise} - API response with favorite reports
 */
export const getFavoriteReports = async () => {
    try {
        const response = await instance.get('/users/favorites', { 
            withCredentials: true 
        });
        return response;
    } catch (error) {
        console.error('Error fetching favorite reports:', error);
        throw error;
    }
};
